/**
 * VENDOR MODULES
 */
import React from 'react';

import { getSportIdForImagePath } from 'shared/utils/sport-colors';
import { withBasePath } from 'shared/utils/runtimeBasePath';

export type OutcomeImagesProps = {
  n_runners?: number | string;
  sport_id?: number | string;
  br?: boolean | number;
  outcome?: string | number;
};

/**
 * Prints the outcome images
 */
function OutcomeImages(props: OutcomeImagesProps) {
  const { n_runners, sport_id, br } = props;
  if (sport_id == null) return null;
  let { outcome: outcomes } = props;
  outcomes = String(outcomes ?? '');
  const arr_outcomes = (outcomes.length == 1) ? [outcomes] : outcomes.split("-");

  /**
   * Results APIs may now return outcome_type_id values (e.g. 2001003) instead of runner codes (e.g. "3").
   * Runner images expect the runner number/code, so normalize outcome_type_id -> runner index.
   */
  const normalizeRunnerToken = (token: string | number): string => {
    const s = String(token ?? '').trim();
    if (!s) return s;
    if (!/^\d+$/.test(s)) return s;

    const n = Number.parseInt(s, 10);
    if (!Number.isFinite(n)) return s;

    const max = Number.parseInt(String(n_runners ?? ''), 10);
    if (Number.isFinite(max) && n >= 1 && n <= max) return String(n);

    const mod = n % 1000;
    if (Number.isFinite(max) && mod >= 1 && mod <= max) return String(mod);

    if (Number.isFinite(max)) {
      const modStr = String(mod);
      if (modStr.length === 2 || modStr.length === 3) {
        const digits = modStr.split('').map((d) => Number.parseInt(d, 10));
        const ok = digits.every((d) => Number.isFinite(d) && d >= 1 && d <= max);
        if (ok) return digits.join('-');
      }
    }

    return s;
  };
  const imageSportId = getSportIdForImagePath(sport_id);
  return (
    <>
      {arr_outcomes.map((outcome, i) => {
        const normalizedOutcome = normalizeRunnerToken(outcome);
        if (!normalizedOutcome) return null;
        return (
          <React.Fragment key={`${i}_${sport_id}`}>
            <img
              src={withBasePath(`/images/runner_${imageSportId}_${n_runners}_${normalizedOutcome}.png`)}
              className="inline-block align-middle w-6 h-6 md:w-8 md:h-8 object-contain"
              alt={`Runner ${normalizedOutcome} for ${sport_id === 10 ? 'Dogs' : sport_id === 20 ? 'Horses' : 'Baseball'}`}
            />
            {(br === true && outcomes.length == 1) && <br />}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default OutcomeImages;
